import { useState } from "react";
import { toast } from "sonner";
import API from "../../../lib/api";
import { useAuth } from "../../../contexts/AuthContext";
import { hasFeature } from "../../../lib/features";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Textarea } from "../../ui/textarea";
import { Label } from "../../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../ui/dialog";
import { HandHeart, PaperPlaneTilt } from "@phosphor-icons/react";
import { err } from "./libraryUtils";

/** "Propose to the library" — offer one of the workspace's own documents to the platform team. Published anonymously after review. */
export function ProposeToLibraryButton({ sourceKind, sourceId, title, compact = false, disabled = false }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(title || "");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  if (!hasFeature(user, "hs_library") || !["super_admin", "admin", "project_manager", "hs_manager"].includes(user?.role)) return null;
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await API.post("/hs/library/proposals", { source_kind: sourceKind, source_id: sourceId, title: name, note });
      toast.success(data.message);
      setOpen(false);
      setNote("");
    } catch (e) { err(e, "Couldn't send the proposal"); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant={compact ? "ghost" : "outline"} className={compact ? "h-7 text-xs px-2" : ""} disabled={disabled} onClick={() => { setName(title || ""); setOpen(true); }} title="Propose this to the platform's Template library" data-testid={`lib-propose-${sourceId}`}>
        <HandHeart size={14} className={compact ? "" : "mr-1"} />{compact ? "" : " Propose to library"}
      </Button>
      <Dialog open={open} onOpenChange={(o) => !o && setOpen(false)}>
        <DialogContent className="max-w-lg" data-testid="lib-propose-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><HandHeart size={18} className="text-primary" /> Propose to the Template library</DialogTitle>
            <DialogDescription>The platform's H&amp;S team reviews it, removes your client, site and people details, and — if it's a good fit — publishes it <b>anonymously</b> for every workspace to copy. Your original isn't changed.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div><Label className="text-xs">Title for the library</Label><Input value={name} onChange={(e) => setName(e.target.value)} className="mt-1 h-9" data-testid="lib-propose-title" /></div>
            <div><Label className="text-xs">Note to the platform team (optional)</Label><Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Why it's useful, what trades it suits, anything they should know" className="mt-1 text-sm" data-testid="lib-propose-note" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="lib-propose-cancel">Cancel</Button>
            <Button disabled={busy || !name.trim()} onClick={submit} data-testid="lib-propose-submit"><PaperPlaneTilt size={14} className="mr-1" /> {busy ? "Sending…" : "Send proposal"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
